module.exports = __webpack_public_path__ + "static/media/how_uk.999c2d8a.vtt";